import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as companyService from "../../services/companyService";
import { handleApiError } from "../storeEffects";
import { CompanyAction, companyFailure, companySuccess } from "./storeCompany";

export type CompanyThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, CompanyAction>

export const getCompanyPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return companyService.getCompanyPage()
        .then(
            companyPage => {
                dispatch(companySuccess(companyPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(companyFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};